import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import classNames from 'classnames';
import dayjs from 'dayjs';

import { useAllSearchParams } from '~libs/searchParams';

import { AccountsOverdueBanner, AnnouncementBanner, Header, QuickMenu } from '~main/components';

import { log } from '~main/actions/login';

import { setHasParent, setViewType } from '~main/reducers/app';

import { selectIsDesktopView, selectViewType } from '~main/selectors/app';

const Home: React.FC = () => {
  const { pathname } = useLocation();
  const params = useParams();
  const dispatch = useAppDispatch();

  const searchParams = useAllSearchParams();

  const viewType = useAppSelector(selectViewType);
  const isDesktop = useAppSelector(selectIsDesktopView);

  useEffect(() => {
    // Add view toggle to remove header/quick menu/navigation items, used for iFrame windows within TP1
    // This must be removed upon close of TP1. (╯°□°）╯︵ ┻━┻
    const { view_type, has_parent } = searchParams;
    dispatch(setViewType(view_type));
    dispatch(setHasParent(has_parent === 'true'));
  }, []);

  useEffect(() => {
    // Log page navigation on change of path
    dispatch(log({ path: pathname, params, query: searchParams, time_utc: dayjs().toISOString() }));
  }, [pathname]);

  if (pathname === '/') return <Navigate to="/home" replace />;

  const containerClass = classNames('app-container', {
    ['prevent-nav']: viewType === 'feature',
    ['print-friendly-view']: viewType === 'print-friendly',
    'desktop-view': isDesktop,
  });

  return (
    <Container fluid className={containerClass}>
      <Header />
      <Row className="app-row gx-0">
        <QuickMenu />
        <Col className="features">
          <AnnouncementBanner />
          <AccountsOverdueBanner />
          <div className="feature">
            <Outlet />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Home;
